"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLLECT_REWARDS_MUTATION = exports.WITHDRAW_MUTATION = exports.DEPOSIT_MUTATION = void 0;
// src/graphql/mutations.ts
const client_1 = require("@apollo/client");
exports.DEPOSIT_MUTATION = (0, client_1.gql) `
  mutation Deposit($amount: Float!, $poolId: String!) {
    deposit(amount: $amount, poolId: $poolId) {
      success
      message
      updatedBalance
    }
  }
`;
exports.WITHDRAW_MUTATION = (0, client_1.gql) `
  mutation Withdraw($amount: Float!, $poolId: String!) {
    withdraw(amount: $amount, poolId: $poolId) {
      success
      message
      updatedBalance
    }
  }
`;
exports.COLLECT_REWARDS_MUTATION = (0, client_1.gql) `
  mutation CollectRewards($poolId: String!) {
    collectRewards(poolId: $poolId) {
      success
      message
      rewardsCollected
    }
  }
`;
//# sourceMappingURL=mutations.js.map